<template>
	<div>
		<div class="header">
			<div style="display: flex;align-items: center;">
				<img src="../../assets/images/indexIcon.png" alt="">
				<p><span>首页-产品服务池</span>-{{productDetail.title}}</p>
			</div>
			<div class="backof" @click="$router.go(-1)">返回</div>
		</div>
		<div class="body">
			<div class="body-left">
				<div v-for="(item,index) in productTags"
					@click='$router.push(`/allsearchRefine?type=tags&tags=${item}`)' style="cursor: pointer;"> {{item}}
				</div>

			</div>
			<div class="body-main" v-if='loading'>
				<div class="main-header">
					<div class="head-left">
						<img :src='getImgSrc(productDetail.image)' style="width: 238px;height: 238px;" alt="">
					</div>
					<div class="head-right">
						<div class="title" style="display: flex;justify-content: space-between;align-items: center;">
							<p>{{productDetail.title}}</p>
							<div @click="$router.push(`/productService/buyFullV?id=${productDetail.id}`)" style="width: 122px;height: 38px;color: white;cursor: pointer;line-height: 38px;text-align: center;font-size: 14px;
								background: #0052D9;border-radius: 5px;">
								购买产品服务
							</div>
						</div>
						<div class="content">
							<p style="font-size: 14px;color: #888;">{{productDetail.user_info.nickname}}</p>
							<div style="margin: 15px 0;"> <el-rate :value='productDetail.score' disabled></el-rate>
							</div>
							<p>根据问题复杂程度，价格不同，具体价格和时间请私信联系。</p>
							<div style="display: flex;margin: 15px 0;">
								<div
									style="font-size: 14px; color: #0052D9;line-height: 32px;text-align: center;width: 104px;height: 32px;background: #E5EDFB;border-radius: 5px;margin-right: 10px;">
									{{productDetail.subjectcate_name}}
								</div>
								<div
									style="font-size: 14px;color: #0052D9;line-height: 32px;text-align: center;width: 104px;height: 32px;background: #E5EDFB;border-radius: 5px;margin-right: 10px;">
									{{productDetail.industry_name}}
								</div>
								<div
									style="font-size: 14px;color: #0052D9;line-height: 32px;text-align: center; width: 104px;height: 32px;background: #E5EDFB;border-radius: 5px;margin-right: 10px;">
									{{productDetail.stage_name}}
								</div>
							</div>
						</div>
						<div class="bottom">
							<span style="color: #0052D9;"><i class="el-icon-view"
									style="font-size: 20px;"></i>{{productDetail.hits}}</span>

							<span style="margin-left:30px;cursor: pointer;"
								:style="productDetail.praise == 1?'color: #0052D9;':''"><i class="iconfont icon-zan"
									v-throttle="[LikeHandler,2000,`click`]"
									style="font-size:20px;"></i>{{productDetail.praiset_num}}</span>

							<span style="margin-left: 30px;cursor: pointer;"
								:style="productDetail.tread==1?'color: #0052D9;':''"><i class="iconfont icon-lacai"
									v-throttle="[ShitHandler,2000,`click`]"
									style="font-size: 18px;">{{productDetail.tread_num}}</i></span>

							<span style="margin-left: 30px;cursor: pointer;"
								:style="productDetail.collect == 1?'color: #0052D9;':''"><i class="iconfont icon-xiai"
									v-throttle="[collectasd,2000,`click`]"
									style="font-size: 18px;"></i>{{productDetail.collect_num}}</span>

							<div style="position: relative;" class="shareIconWrap">
								<span style="margin-left: 30px;cursor: pointer;"
									:style="productDetail.share == 1?'color: #0052D9;':''"><i
										class="iconfont icon-fenxiang"
										style="font-size: 20px;"></i>{{productDetail.share_num}}</span>
								<div class="shareIcon"
									style="position: absolute;background: #fff;width: 200px;display: flex;align-items: center;justify-content: center;left:0px;height: 50px;top:-50px">
									<goShare :zytitle="productDetail.title" @share='reoserceShare'></goShare>
								</div>
							</div>

						</div>
					</div>
				</div>
				<div class="main-body">
					<div class="title">
						<div :class="cardActive==1?'active':''" @click="cardActive=1">介绍</div>
						<div :class="cardActive==2?'active':''" @click="cardActive=2">成功案例</div>
						<div :class="cardActive==3?'active':''" @click="cardActive=3">售后保障</div>
						<div :class="cardActive==4?'active':''" @click="cardActive=4">常见问题</div>
						<div :class="cardActive==5?'active':''" @click="cardActive=5">评价({{pinglunList.length}})</div>
						<div v-if="productDetail.buy_lists.length" :class="cardActive==6?'active':''"
							@click="cardActive=6">购买记录</div>
					</div>
					<div class="showItem" v-if="cardActive==1">
						<div style="display: flex;align-items: center;font-size: 18rpx;color: #222;margin: 15px 0;">
							用户报价:<div>{{productDetail.price_see ? productDetail.price : '无权查看'}}</div>
						</div>
						<div v-html="productDetail.summary_info">
							<p>

							</p>
						</div>

					</div>
					<div class="showItem" v-if="cardActive==6">
						<div>
							<el-table :data="productDetail.buy_lists" stripe style="width: 740px" border="">
								<el-table-column label="用户昵称" width="180" :resizable="false">
									<template slot-scope="scope">
										<span> {{scope.row.nickname}}</span>
									</template>
								</el-table-column>
								<el-table-column label="用户介绍" width="319" :resizable="false">
									<template slot-scope="scope">
										<div style="cursor: pointer;">
											<span v-if="scope.row.info_type == 1"
												@click="$router.push(`/geniusClub/geniusInfo?id=${scope.row.user_id}`)">
												用户主页 </span>
											<span v-if="scope.row.info_type == 2"> <a :href="scope.row.homepage"></a>
											</span>
											<span v-if="scope.row.info_type == 3"> <a :href="scope.row.file"></a>
											</span>
											<span v-if="scope.row.info_type == 4"> {{scope.row.content}} </span>
										</div>
									</template>
								</el-table-column>

								<el-table-column label="定价" width="240" :resizable="false">
									<template slot-scope="scope">
										<span v-if="scope.row.pay_type == 1"> 免费</span>
										<span v-if="scope.row.pay_type == 2"> {{scope.row.price}}</span>
									</template>
								</el-table-column>

							</el-table>
						</div>

					</div>
					<div class="showItem" v-if="cardActive==2">
						<div v-html="productDetail.content_info">

						</div>
					</div>
					<div class="showItem" v-if="cardActive==3">
						<div style="margin-bottom: 20px;" v-if="productDetail.after_sale != null">
							<div style="color: black;" v-html="productDetail.after_sale">

							</div>

						</div>
						<div style="margin-bottom: 20px;" v-else>
							<p style="text-align: center;padding: 20px;">暂未发布</p>
						</div>
					</div>
					<div class="showItem" v-if="cardActive==4">
						<div style="padding-bottom: 20px;border-bottom:1px dashed #F0F0F0;margin-bottom: 20px;"
							v-for="(item,index) in questionList">
							<div>
								<span
									style="background: #0052D9;color: white;font-size: 20px;width: 23px;height: 23px;display: inline-block;line-height: 23px;text-align: center;">Q</span>
								<span style="font-size: 20px;color: black;margin-left: 10px;">{{item.question}}</span>
							</div>
							<div style="margin-top: 15px;display: flex;">
								<span
									style="background: #EEEEEE;color: black;font-size: 20px;width: 23px;height: 23px;display: inline-block;line-height: 23px;text-align: center;">A</span>
								<p style="margin-left: 10px;flex: 1;"> {{item.answer}}</p>
							</div>
						</div>
					</div>
					<div class="showItem" v-if="cardActive==5">
						<div class="pinglun" v-for="(item,index) in pinglunList">
							<div class="userInfo">
								<div style="width: 70px;height: 70px;border-radius: 50%;overflow: hidden;">
									<img :src='getImgSrc(item.avatar)' style="width: 100%;height: 100%;" alt="">
								</div>
								<p>{{item.nickname}}</p>
							</div>
							<div class="content">
								<p style="display: flex;color: black;">满意度：<el-rate :value="item.score"
										disabled></el-rate></p>
								<!-- <p style="font-size: 14px;">{{item.d}}</p> -->
								<div :class="'collapse'" :style="item.collapse ?
								'overflow: hidden;  display: -webkit-box; -webkit-line-clamp:2;  -webkit-box-orient: vertical;width: 700px;text-overflow: ellipsis;'
								:''">
									{{item.evaluate}}
								</div>
								<div v-if="item.evaluate.length > 80"
									style="float: right;cursor: pointer;margin-top: 8px;"
									@click='item.collapse = !item.collapse'>
									<div v-if="item.collapse">展开 <i class="el-icon-caret-bottom"></i></div>
									<div v-else>收起 <i class="el-icon-caret-top"></i></div>
								</div>
							</div>
						</div>
						<div style="display: flex;justify-content: center;margin-top: 15px;">
							<el-pagination background layout="prev, pager, next" :current-page='pinglun.page'
								@current-change='currentChange' :page-size='pinglun.per_page' :total="pinglun.total">
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
			<div class="body-right">
				<div class="body-right">
					<div style="background: #0052D9;" @click="$router.push('/productService/createProductService')">
						<img src='../../assets/images/zhifly.png' alt="" style="width: 20px;height: 18px;"><span
							style="width:80px">发布</span>
					</div>
					<div style="background: #3399FF;position: relative;" class="shareBox">
						<img src='../../assets/images/share.png' alt="" style="width: 19px;height: 19px;"><span
							style="width:80px">分享</span>
						<div class="share"
							style="position: absolute;left:0px;background: rgba(255, 255, 255, 0);width: 200px;display: flex;align-items: center;justify-content: center;left: 0px;height: 50px;">
							<goShare @share='reoserceShare' :zytitle="productDetail.title"></goShare>
						</div>
					</div>
					<div style="background: #FF8F00;" v-throttle="[()=>collectasd('param'),2000,`click`]">
						<img src='../../assets/images/whiteStar.png' alt="" style="width: 22px;height: 19px;"><span
							style="width:80px">关注</span>
					</div>
					<div style="background: #18BC9C;" @click="cardActive=4">
						<img src='../../assets/images/circlewen.png' alt="" style="width: 22px;height: 19px;"><span
							style="width:100px">常见问题</span>
					</div>
					<div style="background: #182349;" @click="$router.push(`/userCenter/pthd/myMessage?type=3&id=${productDetail.user_id}&zuozhe=${productDetail.user_info.nickname}&biaoti=${productDetail.title}`)">
						<img src='../../assets/images/zixun.png' alt="" style="width: 20px;height: 19px;"><span
							style="width:80px">咨询作者</span>
					</div>
					<div style="background:#929292;" @click="$router.push(`/userCenter/pthd/myMessage?id=${0}`)">
						<img src='../../assets/images/error.png' alt="" style="width: 19px;height:18px;"><span
							style="width:80px">纠错整改</span>
					</div>
					<div style="background:palevioletred;" @click="xiajia()">
						<img src='../../assets/images/zixun.png' alt="" style="width: 19px;height: 19px;"><span
							style="width:80px">申请下架</span>
					</div>
					<div  style="background:red;" @click="showDialog = true">
						<img src='../../assets/images/zixun.png' alt="" style="width: 19px;height: 19px;"><span
							style="width:80px">纠错工单</span>
					</div>
					<div  style="background:brown;" @click="showDialog2 = true">
						<img src='../../assets/images/zixun.png' alt="" style="width: 19px;height: 19px;"><span
							style="width:80px">提交问题</span>
					</div>
				</div>
			</div>
			<div v-if="showDialog" class="dialog-overlay">
				<div class="dialog-content">  
				<textarea style="height: 300px;" v-model="correctionSuggestions" placeholder="在这里输入您的纠错意见和建议"></textarea>  
				<div class=".dialog-footer">
				  <button  class="submit-btn" @click="submitCorrections">提交</button>  
				  <button  class="cancel-btn" @click="showDialog = false">取消</button>
				</div>
				</div>  
			</div>
			<div v-if="showDialog2" class="dialog-overlay">
				<div class="dialog-content">  
				<textarea style="height: 300px;" v-model="correctionSuggestions2" placeholder="在这里输入您的问题!"></textarea>  
				<div class=".dialog-footer">
				  <button  class="submit-btn" @click="submitCorrections2">提交</button>  
				  <button  class="cancel-btn" @click="showDialog2 = false">取消</button>
				</div>
				</div>  
			</div>
		</div>
	</div>
</template>

<script>
	import goShare from '../../components/share.vue'
	export default {
		components: {
			goShare
		},
		data() {
			return {
				showDialog2: false,
				correctionSuggestions2: '',
				showDialog: false,
				correctionSuggestions: '',
				cardActive: 1,
				title: '',
				showDetail: false,
				whereForm: "",
				shoucang: false,
				noLike: false,
				heart: false,
				share: false,
				questionList: [],
				pinglun: [{
						scroe: 3,
						data: '2023-05-31',
						content: ' 隐约雷鸣 阴霾天空 但盼风雨来 能留你在此',
						collapse: true
					},
					{
						scroe: 3,
						data: '2023-05-31',
						content: ' 半个世纪以来，气象研究始终面临着严峻的挑战一一全球变暖、极端天气，一系列气候变化不断对气象监测和预报的能力提出更高的要求。与此同时，大数据、云计算、人工智能等新一代信息技术的出现又为研究发展带来了新的机遇，物理模拟与数据驱动方式融合应用，为气象研究和其他领域的发展带来了无限可能性。',
						collapse: true
					}
				],
				pinglunList: [],
				productDetail: {},
				loading: false,
				productTags: [],
				PLpage: 1
			}
		},
		created() {
			this.getProductDetailInfo()
			this.getQuestions()
		},

		methods: {
			//纠错
			submitCorrections() {
			      // 调用 jiucuo 方法来提交建议  
			      this.jiucuo();  
			}, 
			//提交问题
			submitCorrections2() {
			      // 调用 jiucuo 方法来提交建议  
			      this.jiucuo2();  
			}, 
			async jiucuo(){
				if(!this.correctionSuggestions){
					this.$message({
						message: "输入您的纠错意见和建议 ! ", 
						type: 'success',
					})
				}
				const alike = await this.$api.add_jcgongdan({
					user_id:this.productDetail.user_id,
					pro_id:this.productDetail.id,
					pro_title:this.productDetail.title,
					prostatus:2,
					jccontent:this.correctionSuggestions,
					})
				if(alike.code == 1){
					this.$message({
						message: alike.msg,
						type: 'success',
					})
					this.showDialog = false;  
					this.correctionSuggestions = ''; // 清空输入框
				}else{
					this.$message({
						message: alike.msg,
						type: 'warning',
					})
				}
				// this.alike = alike.data
				console.log('下架信息',alike);
			},
			async jiucuo2(){
				if(!this.correctionSuggestions2){
					this.$message({
						message: "输入您的问题 ! ", 
						type: 'success',
					})
				}
				const alike = await this.$api.add_changjianwenti({
					user_id:this.productDetail.user_id,
					// pro_id:this.proDetail.id,
					// pro_title:this.proDetail.title,
					cate_list:6,
					question:this.correctionSuggestions2,
					})
				if(alike.code == 1){
					this.$message({
						message: alike.msg,
						type: 'success',
					})
					this.showDialog2 = false;  
					this.correctionSuggestions2 = ''; // 清空输入框
				}else{
					this.$message({
						message: alike.msg,
						type: 'warning',
					})
				}
				// this.alike = alike.data
			},
			async getProductDetailInfo() {
				const product = await this.$api.getProductDetail({
					id: this.$route.query.id
				})
				this.productDetail = product.data
				this.productTags = product.data.tags.split(',')
				console.log(product);
				this.getCommentList()
				this.loading = true
			},
			//下架
			async xiajia(){
					if (!this.productDetail) {  
				      this.$message({  
				        message: '正在加载数据，请稍后点击申请下架！',  
				        type: 'warning',  
				      });  
				      return; // 退出方法，不继续执行  
				    }  
					const alike = await this.$api.add_gongdan({
						user_id:this.productDetail.user_id,
						pro_id:this.productDetail.id,
						pro_title:this.productDetail.title,
						prostatus:2,
					})
					if(alike.code == 1){
						this.$message({
							message: alike.msg,
							type: 'success',
						})
					}else{
						this.$message({
							message: alike.msg,
							type: 'warning',
						})
					}
			},
			currentChange(e) {
				this.PLpage = e
				this.getCommentList()
			},
			showDetailHandler() {
				this.showDetail = !this.showDetail
			},
			async collectasd(e) {
				console.log(e);
				let col
				if (this.productDetail.collect == 0) {
					col = await this.$api.productCollectHandler({
						id: this.productDetail.id
					})
					if (col.code == 1) {
						this.productDetail.collect = 1
						this.productDetail.collect_num += 1
					}
				} else {
					col = await this.$api.productCollectCancelHandler({
						id: this.productDetail.id
					})
					if (col.code == 1) {
						this.productDetail.collect = 0
						this.productDetail.collect_num -= 1
					}
				}
				this.$message({
					message: col.msg,
					type: 'success',
					center: true
				})
			},
			// reoserceToolShare
			async reoserceShare() {
				// 1项目需求，2资源工具求助，3资源工具，4解决方案，5解决方案求助，6产品服务求助，7产品服务
				const share = await this.$api.shareHandler({
					correlation_id: this.productDetail.id,
					type: 7
				})
				if (share.code == 1) {
					this.productDetail.share = 1
					this.productDetail.share_num += 1
				}
			},
			async getCommentList() {
				const comment = await this.$api.productCommentList({
					product_id: this.productDetail.id,
					page: this.PLpage
				})
				this.pinglunList = comment.data.data.map((item) => {
					item.collapse = true
					item.score *= 1
					return item
				})
				this.pinglun = comment.data
				console.log(this.pinglunList);
			},
			async getQuestions() {
				const que = await this.$api.usuallyQuestions({
					cate_id: 6
				})
				this.questionList = que.data
				console.log(que);
			},
			async LikeHandler() {
				let like
				if (this.productDetail.praise == 0) {
					like = await this.$api.productLiekHandler({
						id: this.productDetail.id
					})
					if (like.code == 1) {
						this.productDetail.praise = 1
						this.productDetail.praiset_num += 1
					}
				} else {
					like = await this.$api.productLiekCancelHandler({
						id: this.productDetail.id
					})
					if (like.code == 1) {
						this.productDetail.praise = 0
						this.productDetail.praiset_num -= 1
					}
				}
				this.$message({
					message: like.msg,
					type: 'success',
					center: true
				})
			},
			// giveShitForTools
			// TakeBackShitFromTools
			async ShitHandler() {
				let shit
				if (this.productDetail.tread == 0) {
					shit = await this.$api.giveShitHandler({
						correlation_id: this.productDetail.id,
						type: 7
					})
					if (shit.code == 1) {
						this.productDetail.tread = 1
						this.productDetail.tread_num += 1
					}
				} else {
					shit = await this.$api.cancelGiveShitHandler({
						correlation_id: this.productDetail.id,
						type: 7
					})
					if (shit.code == 1) {
						this.productDetail.tread = 0
						this.productDetail.tread_num -= 1
					}
				}
				this.$message({
					message: shit.msg,
					type: 'success',
					center: true
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.shareIconWrap {
		.shareIcon {
			display: none !important;
		}

		&:hover {
			.shareIcon {
				display: block !important;
			}
		}
	}

	.shareBox {
		.share {
			display: none !important;
		}

		&:hover {
			.share {
				display: block !important;
			}
		}
	}

	.collapse {
		margin-top: 15px;
	}

	.pinglun {
		display: flex;
		align-items: flex-start;
		border-bottom: 1px dashed #eee;
		padding-bottom: 20px;
		margin-bottom: 30px;

		.content {
			margin-left: 28px;
			flex: 1;


			&>p {}
		}

		.userInfo {
			display: flex;
			flex-wrap: wrap;
			width: 100px;
			justify-content: flex-start;

			p {
				width: 70px;
				text-align: center;
				margin-top: 8px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				color: black;
			}
		}
	}

	.body {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;

		.body-left {
			&>div {
				height: 50px;
				line-height: 50px;
				padding: 0 15px;
				border-bottom: 1px solid #EEEEEE;
				text-align: center;
				cursor: pointer;
			}

			height: auto !important;
			width: 260px;
			background: #FFFFFF;
		}

		.body-main {
			width: 900px;

			.main-body {
				.showItem {
					padding: 30px 25px;
					color: #888888;

					.bottom {
						height: 50px;
						background: #F6F6F6;
						border: 1px solid #EEEEEE;
						margin-top: 50px;
						line-height: 50px;
						padding-left: 30px;
						box-sizing: border-box;
						color: black;
					}

					.yingzu {
						display: flex;
						align-items: center;
						margin: 15px 0;

						img {
							width: 18px;
							height: 18px;
						}

						&>span {
							margin-left: 10px;
						}

						&>span:last-child {
							margin-left: 30px;
						}
					}

					p {

						overflow: hidden;
						text-overflow: ellipsis;
					}

					.wangpan {
						color: black;
						height: 200px;

						input {
							border: 1px solid #c6c6c6;
							height: 25px;
							padding-left: 5px;
							width: 200px;
						}
					}
				}

				.title {
					display: flex;
					height: 40px;
					background: #E5EDFB;

					&>div {
						padding: 0 25px;
						height: 40px;
						line-height: 40px;
						cursor: pointer;
						font-size: 18px;
						margin-right: 30px;
						text-align: center;
						color: #888888;
					}

					.active {
						font-weight: bold;
						color: white;
						border-radius: 20px;
						height: 40px;
						background: #0052D9;
						border-radius: 20px;
					}
				}

				margin-top: 20px;
				padding: 20px 0;
				box-sizing: border-box;
				background: white;
			}

			.main-header {
				display: flex;


				.content {
					margin-top: 10px;

					.biaoti {
						width: 60px;
						display: inline-block;
						text-align: justify;
						text-align-last: justify;
						color: #888888;
					}

					.content-item {
						margin: 20px 5px;
						width: 280px;
					}

					.content-l {}
				}

				.bottom {
					display: flex;
					color: #888888;

					span {
						font-size: 16px;
						display: flex;
						align-items: center;
					}

					margin-top:25px;
				}


				.head-right {
					flex: 1;
					padding: 8px 15px;
					box-sizing: border-box;

					.title {
						font-size: 20px;
						font-weight: bold;
					}
				}

				display: flex;
				background: #FFFFFF;
				padding: 20px;
				box-sizing: border-box;
				background: white;
				height: 280px;
			}
		}

		.body-right {
			flex-wrap: wrap;
			display: flex;

			&>div {
				cursor: pointer;
				margin-bottom: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: white;
				line-height: 50px;
				width: 200px;
				height: 50px;
				background: #0052D9;

				&>img {
					margin-right: 15px;
				}
			}
		}
	}

	.header {
		.backof {
			text-align: center;
			line-height: 30px;
			cursor: pointer;
			width: 80px;
			height: 30px;
			background: #FFFFFF;
			border: 1px solid #D2D2D2;
		}

		display: flex;
		padding: 15px 0;
		align-items: center;
		justify-content: space-between;

		&>div {
			&>img {
				width: 16px;
				height: 16px;
			}

			&>p {
				font-size: 16px;
				margin-left: 10px;

				&>span {
					color: #888888;
				}
			}
		}
	}
	/* 弹出对话框的覆盖层 */
	.dialog-overlay {  
		
	}  
	  
	/* 对话框内容 */  
	.dialog-content {  
	  background: white;  
	  padding: 20px;  
	  border-radius: 8px;  
	  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);  
	  width: 400px; /* 稍微增加宽度以适应更大的文本域 */  
	  text-align: center;  
	}  
	  
	/* 文本域美化并放大 */  
	.text-area {  
	  width: 350px; /* 减去更大的左右padding */  
	  height: 500px; /* 增加高度 */  
	  padding: 20px; /* 增加内边距 */  
	  border: 1px solid #ccc;  
	  border-radius: 4px;  
	  box-sizing: border-box;  
	  margin-bottom: 20px;  
	  font-size: 16px; /* 增加字体大小 */  
	  line-height: 1.6; /* 稍微增加行高以保持可读性 */  
	  resize: none; /* 禁止用户调整文本域大小 */  
	}
	  
	/* 文本域美化 */  
	.text-area {  
	  width: calc(100% - 40px); /* 减去左右padding */  
	  padding: 10px;  
	  border: 1px solid #ccc;  
	  border-radius: 4px;  
	  box-sizing: border-box;  
	  margin-bottom: 20px;  
	  font-size: 14px;  
	  line-height: 1.5;  
	  resize: none; /* 禁止用户调整文本域大小 */  
	}  
	  
	/* 对话框底部按钮样式 */  
	.dialog-footer {  
	  display: flex;  
	  justify-content: center;  
	  gap: 10px; /* 按钮间的间距 */  
	}  
	  
	.submit-btn, .cancel-btn {  
	  padding: 10px 20px;  
	  font-size: 16px;  
	  border: none;  
	  border-radius: 4px;  
	  cursor: pointer;  
	  transition: background-color 0.3s; /* 添加过渡效果 */  
	}  
	  
	.submit-btn {  
	  background-color: #4CAF50; /* 绿色 */  
	  color: white;  
	}  
	  
	.submit-btn:hover {  
	  background-color: #45a049; /* 悬停时颜色变深 */  
	}  
	  
	.cancel-btn {  
	  background-color: #f44336; /* 红色 */  
	  color: white;  
	}  
	  
	.cancel-btn:hover {  
	  background-color: #da190b; /* 悬停时颜色变深 */  
	}  
</style>